import script from "./SubjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectList.vue?vue&type=script&setup=true&lang=js"

import "./SubjectList.vue?vue&type=style&index=0&id=8dc6909a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dc6909a"]])

export default __exports__